import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import ProfileHeader from "../section/ProfileHeader";

import PrescriptionCard from "../section/PrescriptionCard";
import ImageGallery from "../section/ImageGallery";

import {
  ArrowLeft,
  Loader2,
  AlertCircle,
} from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ViewProfile() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [customer, setCustomer] = useState(null);
  const [prescriptions, setPrescriptions] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchCustomer = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axios.get(
        `${API_URL}/api/customers/${id}`
      );

      if (response.data.success) {
        setCustomer(response.data.customer);
        setPrescriptions(response.data.prescriptions || []);
      } else {
        setError("Customer not found.");
      }
    } catch (err) {
      console.error(err);

      if (err.response?.status === 404) {
        setError("Customer not found.");
      } else {
        setError("Unable to load customer details.");
      }
    } finally {
      setLoading(false);
    }
  };

 useEffect(() => {
  fetchCustomer();
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [id]);

  if (loading) {
    return (
      <div className="flex min-h-[70vh] items-center justify-center">
        <div className="text-center">

          <Loader2
            className="mx-auto animate-spin text-blue-600"
            size={46}
          />

          <h2 className="mt-5 text-2xl font-bold">
            Loading Customer...
          </h2>

          <p className="mt-2 text-slate-500">
            Please wait while we fetch customer details.
          </p>

        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex min-h-[70vh] items-center justify-center px-5">

        <div className="w-full max-w-xl rounded-3xl border border-red-200 bg-white p-10 text-center shadow">

          <AlertCircle
            className="mx-auto text-red-500"
            size={60}
          />

          <h2 className="mt-5 text-3xl font-bold">
            Oops!
          </h2>

          <p className="mt-3 text-slate-500">
            {error}
          </p>

          <button
            onClick={() => navigate(-1)}
            className="mt-8 inline-flex items-center gap-2 rounded-2xl bg-black px-6 py-3 font-semibold text-white"
          >
            <ArrowLeft size={18} />
            Back
          </button>

        </div>

      </div>
    );
  }
    return (
    <div className="space-y-8">

      {/* Top Bar */}
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">

        <div>
          <button
            onClick={() => navigate(-1)}
            className="mb-4 inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
          >
            <ArrowLeft size={18} />
            Back
          </button>

          <h1 className="text-4xl font-bold text-slate-900">
            Customer Profile
          </h1>

          <p className="mt-2 text-slate-500">
            View complete customer details and record history.
          </p>
        </div>

      </div>

      {/* Profile Header */}
      <ProfileHeader
  customer={customer}
  prescriptions={prescriptions}
/>

{/* Prescription History */}
<div className="space-y-8">

  <div className="mb-8">

    <h2 className="text-2xl font-bold text-slate-900">
      {customer?.visit_for === "Eye Test"
        ? "Eye Test History"
        : customer?.visit_for === "Lens Only"
        ? "Lens Orders"
        : customer?.visit_for === "Complete Specs"
        ? "Spectacles Orders"
        : customer?.visit_for === "Frame Only"
        ? "Frame Orders"
        : customer?.visit_for === "Specs Repair"
        ? "Repair Tickets"
        : "Prescription History"}
    </h2>

    <p className="mt-2 text-slate-500">
      Total Records : {prescriptions.length}
    </p>

  </div>

  {prescriptions.length === 0 ? (

    <div className="rounded-3xl border border-dashed border-slate-300 py-20 text-center">

      <h3 className="text-2xl font-bold text-slate-900">
        No Records Found
      </h3>

      <p className="mt-3 text-slate-500">
        This customer doesn&apos;t have any record yet.
      </p>

    </div>

  ) : (

    <div className="space-y-8">

      {prescriptions.map((prescription, index) => (

  <div
    key={prescription.id}
    className="space-y-6"
  >

    <PrescriptionCard
      prescription={prescription}
      index={index}
      visitFor={customer?.visit_for}
    />

    {prescription.images?.length > 0 && (
      <ImageGallery
        images={prescription.images}
      />
    )}

  </div>

))}

    </div>

  )}

</div>

    </div>
  );
}